import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

type Props = ControllerRenderProps<FieldValues, string> & {
  label: React.ReactNode;
  defaultChecked?: boolean;
  alignTop?: boolean;
};

function UiCheckBox({ label, alignTop = false, ...rest }: Props): JSX.Element {
  return (
    <FormControlLabel
      control={
        <Checkbox
          disableRipple
          sx={{
            padding: 0,
          }}
          {...rest}
        />
      }
      label={label}
      sx={{
        gap: '6px',
        ...(alignTop && { alignItems: 'flex-start' }),
      }}
    />
  );
}

export default UiCheckBox;
